import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getFloatingGroupStyles } from '../styles/get-floating-group-styles';

export const FloatingGroupUnstyled = ({ items, classes, shouldSupportMobileView }) => (
  <div className={classNames([classes.floatingGroup, 'floating-group', { [classes.mobileView]: shouldSupportMobileView }])}>
    {items.map((item, index) => {
      const itemId = item.id ? item.id : `FloatingItem-${index}`;

      return (
        <div
          key={itemId}
          id={itemId}
          className={`floating-item ${item.className}`}
        >
          {_.isFunction(item.renderItem) && item.renderItem()}
        </div>
      );
    })}
  </div>
);

FloatingGroupUnstyled.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any),
  classes: PropTypes.shape({ floatingGroup: PropTypes.string }).isRequired,
  shouldSupportMobileView: PropTypes.bool,
};

FloatingGroupUnstyled.defaultProps = {
  items: [],
  shouldSupportMobileView: false,
};

export const FloatingGroup = withDefaultStyles(FloatingGroupUnstyled, getFloatingGroupStyles);
